<template>
  <div style="padding:20px;">
    <h1>Inventory Pricing</h1>
    
    <!-- Select Location: <LocationSelector v-model="ls.location" /> -->
    Location: RMGB
    <button :disabled="test" class="btn btn-default" @click="forceRefresh">Force Refresh (takes up to 30 seconds)</button> <p>{{refreshedState}}</p>
    <div style="width:400px" v-if="data[ls.location] && data[ls.location].length > 0">
      <BasicTableComponent :list="data[ls.location]" />
    </div>
  </div>
</template>

<script>
// import ApexCharts from 'apexcharts'
export default {
  name: 'InventoryPricingOld',
  data () { return { 
      refreshedState: '',
      data: {
        RMGB: []
      },
      ls: {
        location: 'RMGB'
      },
      listTitles: {},
      test : false
    } 
  },
  async created () {
    await this.loadData();
  },
  mounted() {
    //this.createChart()
  },
  watch : {
    'ls.location': 'loadData'
  },
  methods: {
    forceRefresh: async function(){
      this.refreshedState = 'Refreshing...'
      this.test = true;
      await this.loadData(true, this.isYTD);
      this.refreshedState = 'Refreshed'
      this.test = false;
    },
    loadData: function(refresh=false){
      this.data[this.ls.location] = [];
      i_axios.post('/Inventory/Pricing', {location:this.ls.location, refresh}).then((r)=>{
        // this.data[this.ls.location] = r.data
        this.data.RMGB = r.data
      })
    }
  },
}
</script>

<style>

</style>
